import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "normalize.css/normalize.css";
import i18n from './i18n/index';
import "./styles/index.scss";
import 'flag-icon-css/css/flag-icons.css';
import { Input, FormModel, Rate, Popover,Select } from 'ant-design-vue';
import { Button, Field, Form, RadioGroup, CellGroup, Cell, Toast, Radio, DatetimePicker, Popup, Uploader, Loading, Overlay, Icon, ImagePreview, Swipe, SwipeItem ,Dialog,Empty} from 'vant';
import '@vant/touch-emulator';
import 'vue2-animate/dist/vue2-animate.min.css';
// if (process.env.NODE_ENV === "development") {
const { mockXHR } = require("../mock");
mockXHR();
// }

Vue.config.productionTip = false;
Vue.use(Button);
Vue.use(Select);
Vue.use(Field);
Vue.use(Form);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(CellGroup);
Vue.use(Cell);
Vue.use(Toast);
Vue.use(Popup);
Vue.use(Input);
Vue.use(FormModel);
Vue.use(Dialog);
Vue.use(Empty);
Vue.use(Rate);
Vue.use(Uploader);
Vue.use(Loading);
Vue.use(Overlay);
Vue.use(Icon);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Popover);
Vue.use(ImagePreview);


new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
